<div class="sidebar-wrapper" [class.collapsed]="collapsed">
  <div class="nav-container">
    <ul class="nav">
      <li *ngFor="let menuItem of menuItems" routerLinkActive #rla="routerLinkActive" [ngClass]="rla.isActive ? (menuItem.children === null ? 'active' : '') : ''" [routerLinkActiveOptions]="{ exact: true }">
        <a [style.display]="menuItem.children === null ? 'flex' : 'none'" [routerLink]="[menuItem.path]" [style.background-color]="rla.isActive ? color : 'transparent'" [style.color]="rla.isActive ? activeFontColor : normalFontColor">
          <i class="material-icons">{{menuItem.icon}}</i>
          <span>{{menuItem.title}}</span>
        </a>
        <div [hidden]="menuItem.children === null" class="collapse-container">
          <a data-toggle="collapse" (click)="checkValidation($event, menuItem.path)" [href]="[menuItem.path]" matTooltip="{{menuItem.tooltip}}" style="padding: 0 15px;" [ngClass]="rla.isActive ? 'parent-active' : ''" class="collapse-a collapsed" [style.color]="normalFontColor">
            <i class="material-icons">{{menuItem.icon}}</i>
            <span>{{menuItem.title}}</span>
            <b class="caret" [style.color]="normalFontColor"></b>
          </a>
          <div id="masters" class="collapse" [id]="[menuItem.id]">
            <ul class="nav">
              <li *ngFor="let subItem of menuItem.children" routerLinkActive #subrla="routerLinkActive" [ngClass]="subrla.isActive ? 'active' : ''">
                <a [routerLink]="[subItem.path]" [style.background-color]="subrla.isActive ? color : 'transparent'" 
                [style.color]="subrla.isActive ? activeFontColor : normalFontColor" style="height: 43px;"   matTooltip="{{subItem.tooltip}}">
                  <i class="material-icons" style="margin-left: 5px;">{{subItem.icon}}</i>
                  <span>{{subItem.title}}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

 